module.exports = __webpack_public_path__ + "img/dzBg-1.b006153b.png";